import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import { useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import BackToTop from './BackToTop'

const LandingLayout = ({ children }) => {
    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [pathname])

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header />
            <Box sx={{ flex: 1 }}>
                {children}
            </Box>
            <Footer />
            <BackToTop />
        </Box>
    )
}

export default LandingLayout
